import { FC, memo, useCallback } from 'react'

import { useTranslation } from '../../../hooks/locale'
import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import GridCard from '../../common/grid-card'
import AnalyticsService from '../../../services/analytics-service'
import {
    landingPageEventCategories,
    cardEventCategories,
    pageTypeEventCategories,
} from '../../../services/analytics-service/categories'
import { CtaButtonText, CtaContainer, Section, StyledGhostButton, Title, TitleContainer } from '../common/styles'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { Offer } from '../../../models/common/offers-model'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { useResponsiveCards } from '../../../hooks/responsive'
import { SliderContainer } from '../../common/listing-card-section/styles'
import { EmblaCarousel } from '../../common/embla-carousel'

interface Props {
    listingSection: ListingSectionTransport
    url: string
    defaultHeading: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const TopRecommendationsSection: FC<Props> = ({
    listingSection,
    url,
    defaultHeading,
    breadcrumbModel,
    offerModel,
    suitablesModel,
}) => {
    const { objects, cta } = listingSection
    const { t } = useTranslation()

    const heading = listingSection.heading || defaultHeading

    const _handleCTAButtonClick = useCallback(() => {
        const eventCategory = landingPageEventCategories.topRecommendationsSection.BOTTOM_CTA_VIEW_RECOMMENDATIONS

        if (cta?.url) {
            AnalyticsService.trackClickEvent(eventCategory, cta.url)
            document.location.href = cta.url
        }
    }, [cta?.url])

    const visibleSlides = useResponsiveCards()
    const slidesToScroll = Math.floor(visibleSlides)

    return (
        <Section id="top-recommendations">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <SliderContainer>
                <EmblaCarousel
                    slides={objects.map((object, index) => (
                        <GridCard
                            key={object.id}
                            index={index}
                            listingObject={object}
                            requestUrl={url}
                            pageName={pageTypeEventCategories.HOME}
                            sectionName={cardEventCategories.sections.TOP_RECOMMENDATIONS}
                            breadcrumbModel={breadcrumbModel}
                            offerModel={offerModel}
                            suitablesModel={suitablesModel}
                            showFeatures={false}
                        />
                    ))}
                    visibleSlides={visibleSlides}
                    slidesToScroll={slidesToScroll}
                    showNav
                    navVariant="top-right"
                    navPosition={{ desktopTop: '-3.5rem', desktopRight: '0', wideTop: '-3.5rem', wideRight: '0' }}
                />
            </SliderContainer>
            {!!cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleCTAButtonClick} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Section>
    )
}

export default memo(TopRecommendationsSection)
